var exports = {
  "kL": "xe533113f--4ad6ac--container",
  "xb": "xe533113f--4ad6ac--container--pessimized",
  "qf": "xe533113f--4ad6ac--placeholder",
};

module.exports = exports;
